export default "__VITE_ASSET__DUAYF_mF__"